import { useThemeStore } from '@/stores/themeStore';

export function useColorScheme(): 'light' | 'dark' {
  const preference = useThemeStore((s) => s.preference);
  const systemScheme = useThemeStore((s) => s.systemScheme);
  return preference ?? systemScheme;
}
